import { BACKEND_URL } from 'src/constants';
import { makeAsyncCall, createFilterParamsString } from 'src/utils';
import { ISpaceUser } from 'src/types';

const handleUpdate = user =>
  makeAsyncCall({
    url: `${BACKEND_URL}space-users/${user.id}`,
    method: 'PUT',
    body: JSON.stringify(user),
  });

const handleDelete = userId =>
  makeAsyncCall({
    url: `${BACKEND_URL}space-users/${userId}`,
    method: 'DELETE',
  });

const handleGetSurveyUsers = surveyId =>
  makeAsyncCall({
    url: `${BACKEND_URL}surveys/${surveyId}/users`,
    method: 'GET',
  });

const unlock = userId =>
  makeAsyncCall({
    url: `${BACKEND_URL}space-users/${userId}/unlock`,
    method: 'POST',
  });

const index = query =>
  makeAsyncCall({
    url: createFilterParamsString(query, `${BACKEND_URL}space-users`),
    method: 'GET',
  });

export const SpaceUserService = {
  update: (
    user:
      | (ISpaceUser & { first_login: boolean | 0 | 1; participantGroupId?: number })
      | { id?: number }
  ) => handleUpdate(user),
  remove: userId => handleDelete(userId),
  getSurveyUsers: surveyId => handleGetSurveyUsers(surveyId),
  unlock: userId => unlock(userId),
  index: query => index(query),
};
